__turbopack_context__.v({
  "card": "staticChannel-module-scss-module__ORnQWW__card",
  "strip": "staticChannel-module-scss-module__ORnQWW__strip",
});
